import { useReduxState } from 'hooks';
import api from 'api';
import { Alert, ConfirmButton } from 'components/common';

import type { AdminUser } from 'shared-types';

interface Props {
  targetUser: AdminUser;
  updateAdmins: (obj: { showLoading?: boolean }) => Promise<void>;
}

const AdminsRemove = ({ targetUser, updateAdmins }: Props) => {
  const { messages } = useReduxState();

  const deleteUser = async () => {
    const response = await api.put(`/admin/users/${targetUser.id}`, {
      roles: targetUser.roles.filter(
        (role) =>
          role !== 'admin' && role !== 'superadmin' && role !== 'supervisor'
      ),
      permissions: []
    });
    if (!response.data.success) return false;
    await updateAdmins({ showLoading: false });
    return true;
  };

  let ownerContent = null;
  if (targetUser.administeredContent?.isOnlyOwner)
    ownerContent = (
      <Alert
        style={{ marginBottom: 10 }}
        text={messages.usersDeleteUserConfirmOwnerWarning}
        type="error-light"
      />
    );

  let supervisorContent = null;
  if (targetUser.roles?.includes('supervisor'))
    supervisorContent = (
      <Alert
        style={{ marginBottom: 10 }}
        text={messages.usersDeleteUserConfirmSupervisorWarning}
        type="warning-light"
      />
    );

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.commonRemove}
      category="danger"
      confirmText={
        <div className="content">
          {ownerContent ? ownerContent : null}
          {supervisorContent ? supervisorContent : null}
          {messages.usersRemoveAdminConfirm}
        </div>
      }
      confirmTitle={messages.usersRemoveAdmin}
      onConfirm={deleteUser}
      successMessage={messages.usersRemoveAdminSuccess}
    />
  );
};

export default AdminsRemove;
